import { PropType, computed, defineComponent } from 'vue'

import { CsDropdown } from '@sunrise/components'
import { storeToRefs } from '@sunrise/pinia'
import { Components } from '@sunrise/types'

import { SearchBoxPropertyType } from '../../cmsElements/M/M_RealEstate_SearchList/M_RealEstate_SearchList.enum'
import { EsrType, EstateTypeId } from '../../ts/service/realEstateService.enum'
import { SearchFilters } from '../../ts/service/realEstateService.interface'
import { useMailAgentStore } from '../../ts/store/mailAgentStoreModule/mailAgentStoreModule'
import { useResultListStore } from '../../ts/store/resultListStoreModule/resultListStoreModule'

import { FlexDirection } from './MsFilterPropertyType.enum'

export default defineComponent({
    name: 'MsFilterPropertyType',
    components: { CsDropdown },
    props: {
        searchFilters: { type: Object as PropType<SearchFilters>, required: true },
        direction: { type: String as PropType<FlexDirection>, default: FlexDirection.ROW },
    },
    setup(props) {
        const resultListStore = useResultListStore()
        const { searchParams, searchBoxPropertyType } = storeToRefs(resultListStore)

        const eSRTypeOptions = computed(() => {
            const options: Components.CsDropdown.DropdownOption[] = []
            Object.values(props.searchFilters).forEach((estate) => {
                options.push({ label: estate.label, value: estate.id })
            })
            return options
        })

        const estateTypeOptions = computed(() => {
            let options: Components.CsDropdown.DropdownOption[] = []
            Object.values(props.searchFilters).forEach((estate) => {
                if (estate.id === searchParams.value.esr?.toString()) {
                    options = estate.estateTypes.map((estateType) => ({
                        label: estateType.label,
                        value: estateType.id,
                    }))
                }
            })
            return options
        })

        function onUpdateESRType(newESRType: string) {
            let etype
            const esrType = Number(newESRType)
            if (searchBoxPropertyType.value === SearchBoxPropertyType.RESIDENTIAL) {
                switch (esrType) {
                    case EsrType.SELL:
                        etype = EstateTypeId.HOUSE
                        break
                    case EsrType.RENT:
                        etype = EstateTypeId.APARTMENT
                        break
                }
            } else if (searchBoxPropertyType.value === SearchBoxPropertyType.COMMERCIAL) {
                etype = EstateTypeId.OFFICE
            }

            resultListStore.resetFilter()
            resultListStore.resetPage()
            resultListStore.$patch({
                searchParams: {
                    esr: esrType,
                    etype,
                },
            })

            updateMailAgentTags()
            updateEstateType()
        }

        function onUpdateEstateType(newEType: string) {
            resultListStore.resetFilter()
            resultListStore.resetPage()
            resultListStore.searchParams.etype = Number(newEType)
            updateMailAgentTags()
            updateEstateType()
        }

        function updateMailAgentTags(): void {
            const etypeLabel = getOptionsLabelByValue(
                estateTypeOptions.value,
                searchParams.value.etype?.toString() || '',
            )
            const radius = searchParams.value.sr

            const mailAgentStore = useMailAgentStore()

            mailAgentStore.resetFilterTags()
            mailAgentStore.$patch({
                tags: {
                    estateType: etypeLabel,
                    searchRadius: `Umkreis ${radius}km`,
                },
            })
        }

        function updateEstateType(): void {
            const selectedEstateType = getOptionsLabelByValue(
                estateTypeOptions.value,
                searchParams.value.etype?.toString() || '',
            )

            resultListStore.updateHeadline(selectedEstateType)
        }

        function getOptionsLabelByValue(options: Components.CsDropdown.DropdownOption[], value: string): string {
            return options.find((option) => option.value === value)?.label || ''
        }

        return {
            FlexDirection,
            searchParams,
            eSRTypeOptions,
            estateTypeOptions,
            onUpdateESRType,
            onUpdateEstateType,
        }
    },
})
